import React from 'react';
import RestorePasswordForm from 'src/components/UI/forms/RestorePassword';

const RestorePassword = () => <RestorePasswordForm />;

export default RestorePassword;
